const types = {
  SET_COMPANIES: 'SET_COMPANIES',
  SET_SYSTEM_COMPANIES: 'SET_SYSTEM_COMPANIES',
  SET_ALL_COMPANIES: 'SET_ALL_COMPANIES',
  SET_COMPANIES_USERS: 'SET_COMPANIES_USERS',
  SET_SEGMENTS: 'SET_SEGMENTS',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/master/mutations-types.js